(() => {
  if (window.__renogyContactFormBootstrapped) return;
  window.__renogyContactFormBootstrapped = true;

  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const MESSAGES = {
    required: 'This field is required.',
    email: 'Please enter a valid email address.',
  };

  const getErrorEl = (field) => document.getElementById(`${field.id}-error`);

  const showFieldError = (field, message) => {
    const errorEl = getErrorEl(field);
    field.classList.add('is-invalid');
    field.setAttribute('aria-invalid', 'true');

    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
  };

  const clearFieldError = (field) => {
    const errorEl = getErrorEl(field);
    field.classList.remove('is-invalid');
    field.removeAttribute('aria-invalid');

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  };

  const validateField = (field) => {
    const rule = field.dataset.validate;
    const value = (field.value || '').trim();

    if (!rule) {
      clearFieldError(field);
      return true;
    }

    if (!value) {
      showFieldError(field, MESSAGES.required);
      return false;
    }

    if (rule === 'email' && !EMAIL_PATTERN.test(value)) {
      showFieldError(field, MESSAGES.email);
      return false;
    }

    clearFieldError(field);
    return true;
  };

  const validateForm = (form) => {
    const fields = form.querySelectorAll('[data-validate]');
    let isValid = true;
    let firstInvalidField = null;

    fields.forEach((field) => {
      const fieldValid = validateField(field);
      if (!fieldValid && !firstInvalidField) {
        firstInvalidField = field;
      }
      if (!fieldValid) {
        isValid = false;
      }
    });

    if (firstInvalidField) {
      firstInvalidField.focus();
    }

    return isValid;
  };

  const isNewsletterChecked = (form) => {
    const checkbox = form.querySelector('.business-contact-form__checkbox-input[name="newsletter"]');
    return Boolean(checkbox && checkbox.checked);
  };

  const updateSubmitButtonState = (form) => {
    const submitBtn = form.querySelector('.business-contact-form__submit');
    if (!submitBtn) return;

    if (isNewsletterChecked(form)) {
      submitBtn.removeAttribute('disabled');
    } else {
      submitBtn.setAttribute('disabled', 'disabled');
    }
  };

  const getSite = () => {
    const currentDomain = window.location.hostname;
    switch (currentDomain) {
    case "uk.renogy.com":
        return {site:"UK",apiUrl:`https://shopify-api.renogy.com`};
    case "www.renogy.com":
        return {site:"US",apiUrl:`https://shopify-api.renogy.com`};
    case "ca.renogy.com":
        return {site:"CA",apiUrl:`https://shopify-api.renogy.com`};
      case "eu.renogy.com":
        return {site:"EU",apiUrl:`https://shopify-api.renogy.com`};
    case "au.renogy.com":
        return {site:"AU",apiUrl:`https://shopify-api.renogy.com`};
    case "de.renogy.com":
        return {site:"DE",apiUrl:`https://shopify-api.renogy.com`};
    case "jp.renogy.com":
        return {site:"JP",apiUrl:`https://shopify-api.renogy.com`};
    case "fr.renogy.com":
        return {site:"FR",apiUrl:`https://shopify-api.renogy.com`};
    case "nl.renogy.com":
        return {site:"NL",apiUrl:`https://shopify-api.renogy.com`};
    case "it.renogy.com":
        return {site:"IT",apiUrl:`https://shopify-api.renogy.com`};
    case "es.renogy.com":
        return {site:"ES",apiUrl:`https://shopify-api.renogy.com`};
    default:
        return {site:"RenogyTest",apiUrl:`https://d-shopify-api.renogy.cn`};
    }
  };

  const resetForm = (form) => {
    if (!form) return;

    form.dataset.contactFormSubmitting = 'false';
    form.reset();
    form.querySelectorAll('[data-validate]').forEach(clearFieldError);
    updateSubmitButtonState(form);
  };

  const buildFormDataPayload = (formData, form) => {
    const firstName = (formData.get('firstName') || '').trim();
    const lastName = (formData.get('lastName') || '').trim();

    return {
      firstName,
      lastName,
      name: `${firstName} ${lastName}`.trim(),
      email: (formData.get('email') || '').trim(),
      phone: (formData.get('phone') || '').trim(),
      country: (formData.get('country') || '').trim(),
      company: (formData.get('company') || '').trim(),
      companySize: (formData.get('companySize') || '').trim(),
      hearAbout: (formData.get('hearAbout') || '').trim(),
      comments: (formData.get('comments') || '').trim(),
      newsletter: formData.get('newsletter') === 'yes',
      leadsPageType: form.dataset.leadsPageType || 'Business',
      pageUrl: window.location.href,
    };
  };

  const showSuccess = () => {
    if (typeof Swal !== 'undefined') {
      Swal.fire({
        text: 'Thank you! Your Form Has Been Submitted.',
        iconHtml: `<svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M29.999 59C13.7071 59 0.5 45.7908 0.5 29.499C0.5 13.2071 13.7071 0 29.999 0C46.2908 0 59.4979 13.2071 59.4979 29.499C59.4979 45.7908 46.2908 59 29.999 59ZM29.999 4.21625C16.0354 4.21625 4.71414 15.5375 4.71414 29.5011C4.71414 43.4646 16.0354 54.7859 29.999 54.7859C43.9625 54.7859 55.2838 43.4646 55.2838 29.5011C55.2838 15.5375 43.9625 4.21625 29.999 4.21625Z" fill="#00805E"/>
          <path d="M18 30L26.3333 38.5L43 21.5" stroke="#00805E" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>`,
        showConfirmButton: true,
        customClass: {
          container: 'my-swal my-swal-success',
        },
      });
      return;
    }

    window.alert('Thank you! Your Form Has Been Submitted.');
  };

  const showError = () => {
    if (typeof Swal !== 'undefined') {
      Swal.fire({
        text: 'failed',
        iconHtml: `<svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M29.999 59C13.7071 59 0.5 45.7908 0.5 29.499C0.5 13.2071 13.7071 0 29.999 0C46.2908 0 59.4979 13.2071 59.4979 29.499C59.4979 45.7908 46.2908 59 29.999 59ZM29.999 4.21625C16.0354 4.21625 4.71414 15.5375 4.71414 29.5011C4.71414 43.4646 16.0354 54.7859 29.999 54.7859C43.9625 54.7859 55.2838 43.4646 55.2838 29.5011C55.2838 15.5375 43.9625 4.21625 29.999 4.21625Z" fill="#A4A4A4"/>
          <path d="M21.9961 21.998L37.9987 38.0007" stroke="#A4A4A4" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
          <path d="M21.9961 38.0007L37.9987 21.998" stroke="#A4A4A4" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>`,
        customClass: {
          container: 'my-swal my-swal-error',
        },
      });
      return;
    }

    window.alert('failed');
  };

  const closeParentModal = (form) => {
    const modal = form.closest('.hightlight-tab-modal');
    if (!modal) return;

    modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.dataset.contactFormSubmitting === 'true') return;

    if (!validateForm(form)) return;
    if (!isNewsletterChecked(form)) return;

    form.dataset.contactFormSubmitting = 'true';

    const submitBtn = form.querySelector('.business-contact-form__submit');
    if (submitBtn) submitBtn.disabled = true;

    const formData = new FormData(form);
    const { site: storeName, apiUrl } = getSite();
    const originDomain = window.location.hostname;
    const payload = {
      storeName,
      formData: JSON.stringify(buildFormDataPayload(formData, form)),
    };

    try {
      const response = await fetch(`${apiUrl}/api/form-collect/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Origin-Domain': originDomain,
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();

      if (result.code === 200) {
        resetForm(form);
        closeParentModal(form);
        showSuccess();
      } else {
        showError();
      }
    } catch (error) {
      console.error(error);
      showError();
    } finally {
      form.dataset.contactFormSubmitting = 'false';
      updateSubmitButtonState(form);
    }
  };

  const bindNewsletterGate = (form) => {
    const checkbox = form.querySelector('input[name="newsletter"]');
    if (!checkbox || checkbox.dataset.newsletterGateBound === 'true') return;

    checkbox.dataset.newsletterGateBound = 'true';

    const sync = () => updateSubmitButtonState(form);
    checkbox.addEventListener('change', sync);
    checkbox.addEventListener('input', sync);
    checkbox.addEventListener('click', sync);
  };

  const bindForm = (form) => {
    if (form.dataset.contactFormBound === 'true') return;
    form.dataset.contactFormBound = 'true';

    bindNewsletterGate(form);
    form.addEventListener('submit', handleSubmit);

    form.querySelectorAll('[data-validate]').forEach((field) => {
      field.addEventListener('blur', () => validateField(field));
      field.addEventListener('input', () => validateField(field));
      field.addEventListener('change', () => validateField(field));
    });

    updateSubmitButtonState(form);
  };

  const syncAllSubmitButtons = () => {
    document.querySelectorAll('.business-contact-form__form').forEach(bindForm);
  };

  const initContactForms = () => {
    document.querySelectorAll('.business-contact-form__form').forEach(bindForm);
  };

  document.addEventListener('DOMContentLoaded', initContactForms);
  document.addEventListener('shopify:section:load', initContactForms);

  window.RenogyContactForm = {
    reset: resetForm,
    init: initContactForms,
    syncSubmit: syncAllSubmitButtons,
  };

  initContactForms();
})();
